/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Routes for the Video Call page
 * @author Matt Panico
 * @module Epic.VideoApp.Features.VideoCall.VideoCall
 */

import { IAddRouteFunction } from "~/app/routes";
import VideoCall from "./VideoCall";

/*
 *
 * IMPORTANT! READ THIS!
 *
 * The contents of this file are loaded and executed during the initial load of the application
 * in the browser even if the route is never actually accessed. DO NOT put any additional code
 * in this file, or import any addition modules as doing so would just add extra bloat to the
 * initial load / startup time for the application.
 *
 * IMPORTANT! READ THIS!
 *
 */

/**
 * Return the URL used to access this page
 */
export function getVideoCallUrl(): string {
	return "/VideoCall";
}

/**
 * Return any URLs that should redirect to this page
 */
export function getVideoCallRedirectPaths(): string[] {
	return ["/Home", "/home", "/HOME"];
}

/**
 * Return whether or not this page requires WebRTC
 */
export function getVideoCallRequiresWebRTC(): boolean {
	return true;
}

/**
 * Register the routes associated with this page
 *
 * @param addRoute A function used to add a route
 */
export default function register(addRoute: IAddRouteFunction): void {
	addRoute(getVideoCallUrl(), VideoCall, getVideoCallRedirectPaths(), getVideoCallRequiresWebRTC());
}
